export default "<h1>Vendor Library</h1>\n"